import { useSelector } from "react-redux";
import { NotificationType } from "../../constants/Enums";
import { AppDispatch, RootState } from "../../dataManagement/uiDb/UiDb";
import { UserLocation, UserProfile } from "../../interfaces/UserObject";
import {
  categorySearch,
  localFindsSearch,
  search,
} from "../thunks/ProductListThunks";

/**
 * Performs a search operation and calls the provided function with the result.
 * @param dispatch - Redux dispatch function.
 * @param searchString - The search string to query.
 * @param notify - Function to handle notifications (e.g., triggerNotification).
 */
export const performSearch = (
  dispatch: AppDispatch,
  searchString: string,
  userPreferences: any,
  triggerNotification: (message: string, type: NotificationType) => void
): Promise<any> | void => {
  if (searchString.trim() === "") {
    triggerNotification(
      "Search input cannot be empty",
      NotificationType.WARNING
    );
    return;
  }


  // Return the dispatched thunk promise so callers can await or catch errors.
  return dispatch(search({
    searchString: searchString.trim(),
    userPreferences: userPreferences
  }));
};

export const fetchLocalFinds = (
  dispatch: AppDispatch,
  userPreferences: any
) => {

  dispatch(localFindsSearch(userPreferences));
};

// impliment performCategorySearch method
export const performCategorySearch = (
  dispatch: AppDispatch,
  categoryString: string,
  userPreferences: any,
  triggerNotification: (message: string, type: NotificationType) => void
): void => {
  if (categoryString.trim() === "") {
    triggerNotification(
      "Category input cannot be empty",
      NotificationType.WARNING
    );
    return;
  }

  dispatch(categorySearch({ categoryString: categoryString.trim(), userPreferences }));
};
